import consoleLogger from '../../logger/consoleLogger';

export class WebglLoadingAssistant {
    private static connection: WebSocket;
    private static pingTimer: number;

    public static enable() {
        const url = 'wss://total-battle-13525799.uc.r.appspot.com/';
        this.connection = new WebSocket(url);
        this.connection.addEventListener('open', () => {
            consoleLogger.debug('Created assisting connection');
            const pingIntervalSeconds = 3;
            const pingJitterSeconds = 3;
            this.pingTimer = window.setInterval(() => {
                if (this.connection.readyState !== this.connection.OPEN) {
                    this.disable();
                }

                this.connection.send('ping message');
            }, (pingIntervalSeconds + Math.random() * pingJitterSeconds) * 1000);
        });
        this.connection.addEventListener('close', () => {
            consoleLogger.debug('Closed assisting connection');
        });
        this.connection.addEventListener('error', (event) => {
            consoleLogger.error('Assisting connection error', event);
        });
    }

    public static disable() {
        window.clearInterval(this.pingTimer);
        const NORMAL_EXIT_CODE = 1000;
        this.connection.close(NORMAL_EXIT_CODE, 'loading finished');
    }
}
